import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ViewImageComponent } from "./view-image.component";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatDialogModule } from "@angular/material/dialog";
import { SwiperModule } from "swiper/angular";

@NgModule({
  declarations: [ViewImageComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    FuseSharedModule,
    MatDialogModule,
    SwiperModule
  ]
})
export class ViewImageModule {}
